import { auth } from '@/firebase'
import { getIdToken } from 'firebase/auth'

/**
 * 发送带认证的 POST 请求
 * @param {string} url - API 路径
 * @param {Object|FormData} body - 请求体（自动检测 FormData）
 * @param {Object} options - 额外选项
 * @param {Object} options.headers - 额外请求头
 * @returns {Promise<Object>} 解析后的 JSON 响应
 * @throws {Error} 请求失败时抛出错误，包含服务端错误信息
 */
export async function apiPost(url, body, options = {}) {
  const isFormData = body instanceof FormData
  const headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...options.headers
  }

  if (options.auth !== false) {
    if (!auth.currentUser) {
      const error = new Error('User not authenticated')
      error.status = 401
      throw error
    }

    const idToken = await getIdToken(auth.currentUser)
    headers.Authorization = `Bearer ${idToken}`
  }

  const response = await fetch(url, {
    method: 'POST',
    keepalive: options.keepalive === true,
    headers,
    body: isFormData ? body : JSON.stringify(body)
  })

  if (!response.ok) {
    let errorMessage = `HTTP ${response.status}`
    let errorData = {}
    try {
      errorData = await response.json()
      errorMessage = errorData.error || errorData.message || errorMessage
    } catch {
      // 响应非 JSON 格式，使用默认错误信息
    }
    const error = new Error(errorMessage)
    error.status = response.status
    error.code = errorData.code || null
    // 错误附带的其他字段，例如超出时长限制时的视频时长和方案上限
    error.details = errorData
    throw error
  }

  return response.json()
}

export async function apiPostBlob(url, body) {
  if (!auth.currentUser) {
    const error = new Error('User not authenticated')
    error.status = 401
    throw error
  }

  const idToken = await getIdToken(auth.currentUser)
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}`)
    error.status = response.status
    throw error
  }
  return response.blob()
}
